document.addEventListener("DOMContentLoaded", () => {

    const buttons = document.querySelectorAll(".gallery-filter");
    const items = document.querySelectorAll(".design-gallery-item");
    const empty = document.querySelector(".gallery-empty");

    function normalize(value) {
        return value.toLowerCase().trim();
    }

    function filterGallery(filter) {

        let visibleCount = 0;

        items.forEach(item => {

            const tags = item.dataset.filters
                .split(",")
                .map(tag => normalize(tag));

            const visible = !filter || tags.includes(normalize(filter));

            if (visible) {

                visibleCount++;

                item.style.display = "";

                requestAnimationFrame(() => {
                    item.style.opacity = "1";
                    item.style.transform = "scale(1)";
                });

            } else {

                item.style.opacity = "0";
                item.style.transform = "scale(.98)";

                setTimeout(() => {
                    item.style.display = "none";
                }, 180);

            }

        });

        empty.hidden = visibleCount !== 0;
    }

    buttons.forEach(button => {

        button.addEventListener("click", () => {

            // eemalda aktiivne klass kõigilt nuppudelt
            buttons.forEach(btn => btn.classList.remove("active"));

            // märgi aktiivseks ainult valitud nupp
            button.classList.add("active");

            const group = button.dataset.group;

            if (group === "all") {

                filterGallery(null);

            } else {

                filterGallery(button.dataset.value);

            }

        });

    });

});